import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isBeamUser } from '../Utils/HelperFunctions';
import { FORM_COMPONENTS, FORM_LABELS, BEAM_FORM_COMPONENTS, BEAM_FORM_LABELS } from '../Constants/Constants';

const FormSelector = ({ onChange }) => {
  const navigate = useNavigate();

  return (
    <select
      className='form-select form-select-lg mb-3'
      aria-label='Default select example'
      onChange={e => {
        const LABELS = isBeamUser() ? BEAM_FORM_LABELS : FORM_LABELS;
        if (LABELS[e.target.value] === LABELS.COPY_TRANSFER) {
          navigate('/copy-transfer');
        } else onChange(e.target.value);
      }}>
      <option>Select Action</option>
      {isBeamUser()
        ? Object.keys(BEAM_FORM_COMPONENTS).map(key => (
            <option key={key} value={key}>
              {BEAM_FORM_LABELS[key]}
            </option>
          ))
        : Object.keys(FORM_COMPONENTS).map(key => (
            <option key={key} value={key}>
              {FORM_LABELS[key]}
            </option>
          ))}
    </select>
  );
};

export default FormSelector;
